<template>
  <core-form col="1" label-align="left" label-width :editable="true" label-direction="vertical" style="height: 100%; position: relative; overflow: auto">
    <Spin fix v-if="isSpin">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <!-- 旧的UI选择 -->
    <core-form-item label="布局切换" v-if="isshowchangethema && !isUiStyle">
      <div class="test__body layout__body">
        <Row :gutter="16" v-for="(layout, index) in layouts" :key="layout.name + index" style="margin-bottom: 8px">
          <i-col v-for="(thema, index) in layout.themas" :key="thema.desc + index" :xs="12" :sm="12" :md="12" :lg="6">
            <Card :bordered="false" class="fx__item">
              <!-- <span class="uiconfig_body-icon fx__opera fa fa-caret-down fa-2x"></span> -->
              <p slot="title">{{ layout.text }} - {{ thema.desc }}</p>
              <a href="#" slot="extra" @click.prevent="changeLimit(layout, thema.style)">应用</a>
              <img :src="getsrc(layout, thema.style)" @click="changeLimit(layout, thema.style)" style="width: 100%; height: auto; cursor: pointer" />
            </Card>
          </i-col>
        </Row>
      </div>
    </core-form-item>
    <!-- 自定义UI选择 -->
    <core-form-item label="切换布局" v-if="isshowchangethema && isUiStyle && uistyle.length > 1">
      <!-- pc -->
      <!-- <span title="Ctrl+点击鼠标左键打开提示" class="fa fa-question-circle fa-lg uiconfig_icon" @click.ctrl="test" v-if="$store.state.core.user.isAdmin"></span> -->
      <div class="test__body layout__body" style="width: 100%" v-if="$app.helper.screen.isPC">
        <Row :gutter="16" style="margin-bottom: 8px; width: 100%">
          <template v-for="(item, index2) in uistyle" >
          <i-col class="uiconfig_item" style="overflow: hidden; padding: 8px" :key="index2" v-if="item.key"  :xs="24" :sm="12" :md="12" :lg="6">
            <Card :bordered="false" class="fx__item" >
              <!-- <span class="uiconfig_body-icon fx__opera fa fa-caret-down fa-2x"></span> -->
              <p class="uiconfig_title" slot="title" :class="{'fx-color-brand':$store.state.core.uiKey==item.key}">{{ item.title }}</p>
              <!-- <a href="#" slot="extra" @click.prevent="changeLimit2(item)">应用</a> -->
              <div class="uiconfig_body" @click.prevent="changeLimit2(item)" style="height: 210px; max-height: 210px; width: 100%; cursor: pointer" :style="{ background: `url(${item.imgurl})center top/ 100% auto no-repeat` }"></div>
            </Card>
          </i-col>
          </template>
        </Row>
      </div>
    </core-form-item>
    <!-- <component :is="layoutsComponent"></component> -->
  </core-form>
</template>
<script>
// import plupload from "plupload";
// import pc2 from "./layout-pc2";
// import top from "./layout-top";
export default {
  data() {
    const winWidth = this.$app.helper.screen.winWidth;
    let layouts = [];
    const pc2Themas = [
      { style: "dark", desc: "黑色风格" },
      { style: "light", desc: "白色风格" },
      { style: "blue", desc: "蓝色风格" },
    ];
    const topThemas = [
      { style: "dark", desc: "黑色风格" },
      { style: "blue", desc: "蓝色风格" },
    ];

    // PC与移动端的布局筛选
    if (this.$app.helper.screen.isPC) {
      this.$app.layout.layouts.filter((t) => {
        if (t.name === "pc2") {
          layouts.push({
            themas: pc2Themas,
            ...t,
          });
        }
        if (t.name === "top") {
          layouts.push({
            themas: topThemas,
            ...t,
          });
        }
      });
    }
    return {
      layouts,
      layoutsComponent: this.$store.state.core.layout,
      uistyle: [],
      isSpin: false,
      // themas
      // thema: "",
      // themaColor: "",
    };
  },
  components: {
    // pc2,
    // top
  },
  mounted() {
    let _this = this;
    _this.$nextTick(() => {
      if (_this.isUiStyle) _this.getUistyle();
    });
  },
  computed: {
    isshowchangethema() {
      return this.$app.helper.screen.isPC && this.$app.ProjSetting.disablethema != true;
    },
    isUiStyle() {
      return this.$store.state.core.isUiStyle;
    },
    // uistyle() {
    //   //分为

    //   return this.$store.state.core.uistyle;
    // },
    // curthema: {
    //   get() {
    //     return this.$store.state.core.thema;
    //   },
    //   set(val) {
    //     this.$curl.post("/api/core/personal/saveThema", { thema: val }).then((res) => {
    //       this.$store.commit("corgete/setThema", val);
    //     });
    //   },
    // },
  },
  methods: {
    getUistyle() {
      let _this = this;
      _this.isSpin = true;
      let device = _this.$app.helper.screen.isPC ? "pc" : "phone";
      _this.$curl
        .get("/api/core/personal/getUistyle", { device })
        .then((res) => {
          // this.$store.commit("corgete/setThema", val);
          _this.uistyle = res.uistyle;
        })
        .finally(() => {
          _this.isSpin = false;
        });
    },
    //获取图片默认展示
    getsrc(layout, thema) {
      return ""
      // return require(`../images/${layout.name}-layout-${thema}.png`);
    },
    changeLimit(layout, thema) {
      let _this = this;
      _this.$curl
        .post("/api/core/personal/saveThema", {
          layout: layout.name,
          thema,
          img: _this.$store.state.core.sideBarimg,
          topimg: _this.$store.state.core.topimg,
        })
        .then((res) => {
          window.location.reload();
        });
    },
    changeLimit2(userUistyle) {
      let _this = this;
      _this.$curl
        .post("/api/core/personal/saveThema2", {
          layout: userUistyle.layout,
          thema: userUistyle.thema,
          device: _this.$app.helper.screen.isPC ? "pc" : "phone",
          title: userUistyle.title,
          menu: userUistyle.menu,
          key: userUistyle.key,
          headline: userUistyle.headline,
          img: _this.$store.state.core.sideBarimg,
          topimg: _this.$store.state.core.topimg,
        })
        .then((res) => {
          window.location.reload();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.uiconfig_item {
  &:hover {
    .uiconfig_title {
      font-weight: bold;
    }
  }
}
.uiconfig_body {
}
.uiconfig_icon {
  position: absolute;
  top: -22px;
  /* right: 0px; */
  left: 60px;
  cursor: pointer;
}
.uiconfig_body-icon {
  position: absolute;
  top: 0;
  left: 46%;
}
@media screen and (min-width: 995px) and (max-width: 1600px) {
  .uiconfig_item {
    .ivu-card {
      .ivu-card-body {
        .uiconfig_body {
          height: 150px !important;
          background-position: center center !important;
        }
      }
    }
  }
}
@media screen and (min-width: 586px) and (max-width: 800px) {
  .uiconfig_item {
    .ivu-card {
      .ivu-card-body {
        .uiconfig_body {
          height: 150px !important;
          background-position: center center !important;
        }
      }
    }
  }
}
</style>
